var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.902,29.63v-2.118c0-1.44-0.626-2.806-1.718-3.745c-1.092-0.938-2.534-1.353-3.958-1.139l-40.916,6.169 c-1.941,0.293-3.683,1.321-4.904,2.895c-0.085,0.109-0.156,0.225-0.215,0.345c-0.88,1.121-1.41,2.53-1.41,4.063v23.551 c0,3.638,2.959,6.598,6.597,6.598h45.243c3.638,0,6.598-2.96,6.598-6.598v-7.774v-8.002V36.1 C77.219,32.901,74.929,30.228,71.902,29.63z M66.823,26.583c0.367-0.057,0.63,0.111,0.752,0.217 c0.122,0.105,0.327,0.337,0.327,0.712v1.991H47.458L66.823,26.583z M70.621,62.249H25.378c-1.432,0-2.597-1.165-2.597-2.598V36.1 c0-1.432,1.165-2.597,2.597-2.597h44.524h0.719c1.433,0,2.598,1.165,2.598,2.597v5.774h-6.152c-3.309,0-6.001,2.692-6.001,6.001 c0,3.309,2.692,6.001,6.001,6.001h6.152v5.774C73.219,61.084,72.054,62.249,70.621,62.249z M73.219,49.877h-6.152 c-1.104,0-2.001-0.897-2.001-2.001s0.897-2.001,2.001-2.001h6.152V49.877z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.3ef1736d727f81d41fe2f0b3ea3d6361.svg";
export { ForwardRef as ReactComponent };